<template>
  <div style="font-size: 20pt; color: white">
    <v-btn icon @click="$emit('screenSwitch', {procedure: null})">
      <LATIcon icon="bars" color="white"></LATIcon>
    </v-btn>
    <v-btn v-if="debugActive" @click="testSomething" x-small>Test Button</v-btn>
    <div v-show="debugActive" ref="monitor" style="position: fixed; right: 0; top: 0"></div>
  </div>
</template>

<script>

import {aircraftConfig, settings} from "../config";
import LATIcon from "./Icon/LATIcon";
import {createStats} from '../modules/LAT/panorama'
import {procedureTeacher} from "../modules/ProcedureTeacher";

export default {
  name: "HeaderOverlay",
  components: {LATIcon},
  computed: {
    debugActive(){
      return settings.DEBUGVISIBLE
    }
  },

  data: ()=> ({
    marker: {
      position: {}
    },
    currentTexture: 'cockpit'
  }),

  mounted() {
    this.stats = createStats()
    this.$refs.monitor.appendChild( this.stats.domElement );
  },

  methods: {
    testSomething(){

      // this.$LAT.panorama.fadeOut();

      // toggleStarWarp(this.$LAT.scene);

      procedureTeacher.selectDefaultProcedure();
      //
      // this.currentTexture = this.currentTexture === 'cockpit' ? 'cockpit_off' : 'cockpit';
      // this.$LAT.textureSwitcher.changeTo(this.currentTexture)
    }
  }
}
</script>

<style scoped>

</style>